"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.is_object = is_object;
exports.hasArg = hasArg;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Check if the value is a javascript object.
 *
 * @param value
 * @returns {boolean}
 */
function is_object(value) {
  var type = _typeof(value);

  return value !== null && (type === 'object' || type === 'function');
}
/**
 * Check a string has arguments with the delimiter format
 *
 * @param value
 * @param delimiter
 * @returns {boolean|boolean}
 */


function hasArg(value) {
  var delimiter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ':';
  return typeof value === 'string' && value.split(delimiter).length > 1;
}